import {useMemo} from 'react';

import {useTranslation} from 'react-i18next';

import {Box, Grid, SxProps, Typography, useMediaQuery, useTheme} from '@mui/material';

import {ApplicantMatchesMobileList} from './ApplicantMatchesMobileList';
import {ApplicantMatchesTable} from './ApplicantMatchesTable';
import EmpionLogo from '../../../../../components/EmpionLogoAnimation/EmpionLogo';
import {greenColors, orangeColors} from '../../../../../layouts/theme/designSystem';
import {Match} from '../../types/ApplicantMatchesTypes';

interface ApplicantMatchesProps {
  matches?: Match[];
}

const cardStyles: SxProps = {
  bgcolor: 'white',
  border: `1px solid ${orangeColors[3]}`,
  borderRadius: '16px',
  px: {xs: 2, sm: 3},
  pt: 3,
  pb: 4,
};

export default function ApplicantMatches({matches}: ApplicantMatchesProps) {
  const {t} = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const sortedMatches = useMemo(() => {
    return (matches || []).slice().sort((a: Match, b: Match) => {
      return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
    });
  }, [matches]);

  const hasMatches = sortedMatches.length > 0;

  return (
    <Box sx={{...cardStyles, minHeight: '164px'}}>
      <Typography variant='h2' sx={{color: greenColors[700], mb: 2}}>
        {t('applicantDashboard.matchesView.title')}
      </Typography>

      {hasMatches ? (
        isMobile ? (
          <ApplicantMatchesMobileList matches={sortedMatches} />
        ) : (
          <ApplicantMatchesTable matches={sortedMatches} />
        )
      ) : (
        <Grid overflow='hidden'>
          <EmpionLogo withAnimation />
          <Typography variant='h4' sx={{color: greenColors[100], mb: 2, textAlign: 'center'}}>
            {t('applicantDashboard.matchesView.noMatches')}
          </Typography>
        </Grid>
      )}
    </Box>
  );
}
